
export default {
  name: 'simpleText',
  props: {
    content: [String, Array]
  },
  computed: {
    label () {
      if (Array.isArray(this.content)) {
        return this.content.join('\n')
      }
      return this.content || ''
    }
  }
}
